import Vue from "vue";
import ExportDialogContent from "./RemunerationExportDialogContent.vue";
export default Vue.extend({
    data() {
        return {
            animationSettings: { effect: "None" },
            contentTemplate: function () {
                return {
                    template: ExportDialogContent
                };
            }
        };
    },
    methods: {
        show(officeId) {
            // The content sets the office before the dialog is shown
            this.$emit("show", officeId);
            this.$refs.employeesExportDialog.show();
        },
        hide() {
            this.$refs.employeesExportDialog.hide();
        }
    }
});
